<template>
	<div class="BuildCodingTest-main-container">
		<div class="d-flex align-items-center position-relative">
			<div class="d-flex">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					alt=""
					class="pointer"
				/>
			</div>
			<div class="tc-yellow-position">
				<img src="../../assets/yellowOval.svg" alt="" />
			</div>
			<div class="tc-main-head ml-3" style="z-index: 2">Preview Question</div>
		</div>
		<template>
			<div>
				<div class="tc-preview-container d-flex mb-1 mt-3">
					<div class="tc-preview-left" style="width: 50%">
						<div class="d-flex align-items-center mt-3 ml-1">
							<div class="qpc-small-box">
								Difficulty Level: {{ question.difficultyLevel }}
							</div>
							<div class="qpc-small-box">Marks: {{ question.marks }}</div>
							<div class="qpc-small-box">
								Category : <b>{{ question.category }}</b>
							</div>
						</div>
						<div class="qpc-tags-text mt-3 ml-1">
							Tags :
							<span v-for="(tag, k) in question.questionTags" :key="k">
								{{ tag
								}}<span v-if="k < question.questionTags.length - 1"
									>,</span
								></span
							>
						</div>
						<div>
							<div class="mt-3">
								<span class="qpc-totalQuesnum mb-3">{{ question.title }}</span>
							</div>
							<div
								class="tc-preview-head mt-3"
								style="text-decoration: underline"
							>
								Question:
							</div>
						</div>
						<div
							class="tc-card-subtext mt-1 mb-4 ml-2"
							style="width: 86%; margin: 12px 0px 25px 9px"
							v-html-safe="question.question"
						></div>
						<div class="tc-TC-card p-3 m-2">
							<span class="tc-preview-head">Constraints: </span>
							<div
								class="mt-3 tc-card-subtext"
								v-html-safe="question.constraints"
							></div>
						</div>
						<div class="tc-TC-card p-3 m-2">
							<span class="tc-preview-head">Sample: </span>
							<div class="p-3 tc-card-subtext d-flex flex-column">
								Input:
								<span v-html-safe="question.sampleInput" />
								Output:
								<span v-html-safe="question.sampleOutput" />
							</div>
						</div>
						<div class="tc-TC-card p-3 m-2">
							<span class="tc-preview-head">Test Cases: </span>
							<div class="d-flex">
								<div class="tc-many-testCase-left" style="width: 25%">
									<!--********************   SELECTED TEST CASE CLASS  *********************-->
									<div
										v-for="(tc, k) in question.testCases"
										:key="k"
										@click="selecttestcase(k)"
										:class="
											viewtestcase == k
												? 'p-2 bct-many-testCase-sel-text'
												: 'p-2 bct-many-testCase-text'
										"
									>
										Test Case {{ k + 1 }}
									</div>
								</div>
								<div class="tc-many-testCase-right" style="width: 75%">
									<div class="tc-TC-card p-3 m-2">
										<span class="tc-preview-head">Input: </span>
										<div class="tc-card-subtext ml-3 mt-2">
											{{ question.testCases[viewtestcase].inputValue }}
										</div>
									</div>
									<div class="tc-TC-card p-3 m-2">
										<span class="tc-preview-head">Output: </span>
										<div class="tc-card-subtext ml-3 mt-2">
											{{ question.testCases[viewtestcase].outputValue }}
										</div>
									</div>
									<div class="bct-TC-card p-3 m-2">
										<span class="bct-preview-head"
											>Visible:
											<div class="bct-card-subtext mt-2">
												{{ question.testCases[viewtestcase].visibility }}
											</div></span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tc-preview-line-box" style="width: 1%"></div>
					<div style="width: 49%; overflow: auto" class="ml-3">
						<div class="tc-code-body-preview p-3 mr-1">
							Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nesciunt
							maiores consequuntur voluptas impedit vel at in ratione enim.
							Commodi, qui. Ad id eos exercitationem corrupti saepe ab placeat,
							inventore voluptate atque, molestiae labore harum doloribus
							commodi. Iusto deserunt dicta omnis suscipit harum officia sunt,
							optio odit enim architecto! Sunt voluptates veritatis officiis
							dolorum nisi aperiam qui soluta doloribus necessitatibus quo,
							quas, similique deserunt consequatur veniam quod ut impedit unde
							at. Nulla itaque, accusantium, cumque neque alias, magnam debitis
							deleniti id vel cupiditate officiis! Sunt cupiditate illo eos
							suscipit doloremque magnam eligendi laboriosam perferendis, a
							minus rem, molestias recusandae ipsa optio! Eaque beatae numquam
							dolorem ut quaerat obcaecati quas nisi repudiandae illum, ipsum
							molestias rem eos odio. Sint saepe vel, neque, consequatur,
							tempore alias voluptates impedit laboriosam provident illum sit
							vero obcaecati voluptatibus temporibus aut optio suscipit! Impedit
							nisi, exercitationem obcaecati magnam atque, soluta voluptatum quo
							consectetur sit ullam eaque officiis saepe repudiandae quia
							voluptates odio dolorum sunt qui.
						</div>
					</div>
				</div>
				<div
					class="tc-bottom-button d-flex align-items-center justify-content-end"
				>
					<div class="tc-cancel-btn-parent">
						<b-button class="tc-cancel-btn mr-4">Back to Question</b-button>
					</div>
					<b-button class="tc-save-btn" @click="goToDocumentUpload()"
						>Save & Next</b-button
					>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { getcodingquestion } from "../../utils/apiFunctions.js";
export default {
	name: "PreviewCodeTest",
	data() {
		return {
			loopVar: 2,
			loopVar2: 5,
			viewtestcase: 0,
			question: {
				category: "",
				config: [],
				constraints: "",
				defaultBody: { CODELANG002: { head: "see", body: "no", tail: "true" } },
				question: "",
				marks: "",
				difficultyLevel: "",
				questionTags: [],
				sampleInput: "",
				sampleOutput: "",
				status: "",
				testCases: [],
				title: "",
			},
		};
	},
	async created() {
		if (this.$route.query.questionKey) {
			this.getQuestion(this.$route.query.questionKey);
		}
	},
	methods: {
		async getQuestion(key) {
			const res = await getcodingquestion(key);
			this.question = res.data.data;
			delete this.question.active;
			delete this.question.actualQuestion;
			delete this.question.addToPublic;
			delete this.question.addToDatabank;
			delete this.question.createdAt;
			delete this.question.createdBy;
			delete this.question.licenseKey;
			delete this.question.questionMedia;
			delete this.question.questionMediaType;
			delete this.question.updatedAt;
		},
		selecttestcase(index) {
			this.viewtestcase = index;
		},
	},
};
</script>
<style>
.qpc-tags-text {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.BuildCodingTest-main-container {
	padding: 90px 20px 0px 80px;
}

.tc-yellow-position {
	position: absolute;
	left: 22px;
	z-index: 1;
}

.tc-main-head {
	font-weight: 600;
	font-size: 18px;
	color: #464667;
}

.tc-ques {
	position: absolute;
	left: 250px;
	top: 15px;
}

.tc-bottom-button {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
}

.tc-cancel-btn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc-save-btn {
	background: #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}
.bct-preview-head {
	font-size: 13px;
	font-weight: 500;
	color: #333333;
}
.bct-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}
.bct-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.BuildCodingTest-main-container .tc-cancel-btn-parent .btn-secondary:focus,
.btn-secondary.focus {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.BuildCodingTest-main-container .tc-cancel-btn-parent .btn-secondary:hover {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc .tc-cancel-btn-parent .btn-secondary:focus,
.btn-secondary.focus {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc .tc-cancel-btn-parent .btn-secondary:hover {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc-select:focus {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.tc-select:hover {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.tc-select:active {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.cke_bottom {
	display: none !important;
}

.cke_chrome {
	display: block;
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
	border-radius: 3px !important;
	padding: 0;
}

.tc-ck1 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 180px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.tc-ck2 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 145px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.tc-ck3 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 190px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.tc-ck1 .cke_contents {
	display: block;
	height: 115px !important;
	overflow: hidden;
}

.tc-ck2 .cke_contents {
	display: block;
	height: 85px !important;
	overflow: hidden;
}

.tc-ck3 .cke_contents {
	display: block;
	height: 125px !important;
	overflow: hidden;
}

.cke_top {
	border-bottom: 1px solid #ececec !important;
	background: #f8f8f8;
	padding: 6px 8px 2px;
	white-space: normal;
	border-radius: 3px !important;
}

.cke_wysiwyg_frame,
.cke_wysiwyg_div {
	background-color: #fff;
	border-radius: 3px !important;
}

.cke_reset {
	margin: 0;
	padding: 0;
	border: 0;
	background: transparent;
	text-decoration: none;
	width: auto;
	height: auto;
	vertical-align: baseline;
	box-sizing: content-box;
	position: static;
	transition: none;
}
.bct-many-testCase-sel-text {
	font-weight: 600;
	font-size: 14px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}
.bct-many-testCase-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}
.BuildCodingTest-main-container .form-control {
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
}
.b-form-tags input::placeholder {
	color: #6d6d6d !important;
	opacity: unset;
}
.tc-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}

.tc-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.tc-code-body-preview {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 335px);
	color: #ffffff;
	font-size: 14px;
}

.tc-preview-container {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: calc(100vh - 205px);
	padding: 20px;
}

.tc-preview-line-box {
	border-right: 0.5px solid #adaaaa;
	height: calc(100vh - 245px);
}

.tc-preview-left {
	overflow: auto;
}

.tc-preview-head {
	font-size: 13px;
	font-weight: 500;
	color: #333333;
}

.tc-many-testCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #fbfafa;
	border-radius: 5px;
}

.tc-many-testCase-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}

.tc-many-testCase-right {
	min-height: auto;
	max-height: calc(100vh - 620px);
	overflow: auto;
}

.tc-many-testCase-sel-text {
	font-weight: 600;
	font-size: 14px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}

.tc-many-trialCase-sel-text {
	background: #eef2f5;
}

.tc-many-trialCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #ffffff;
	border: 1px solid rgba(196, 196, 196, 0.25);
	border-radius: 3px;
}

.tc-test-result {
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}

.tc-greenTop {
	background: #1cb803;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.tc-redTop {
	background: #f15c6a;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}
.qpc-small-box {
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	font-weight: 500;
	font-size: 11px;
	color: #3f698e;
	padding: 6px 17px;
	margin-right: 20px;
}
.tc-greenText {
	font-weight: 500;
	font-size: 12px;
	color: #1cb803;
}
.qpc-totalQuesnum {
	font-weight: 600;
	font-size: 16px;
	color: #333333;
}
</style>
